module.exports = __webpack_public_path__ + "static/media/17-web-or-mls-DSC06480.d1132592.jpg";